import React from 'react';
import { Box } from '@mui/material';
import { ScorecardDataItem } from 'api/scorecard';
import { EditRowButton } from '../editRowButton';
import { DeleteRowButton } from '../deleteRowButton';
import { ArchiveRowButton } from '../archiveRowButton';

interface RowActionsProps {
    rowData: ScorecardDataItem;
    archived?: boolean;
    disabled?: boolean;
}

export const RowActions: React.FC<RowActionsProps> = ({ rowData, archived = false, disabled = false }) => (
    <Box sx={{ display: 'flex', gap: 1 }}>
        <DeleteRowButton rowId={rowData.rowId} disabled={disabled} />
        {archived ? (
            <ArchiveRowButton rowId={rowData.rowId} archived={archived} disabled={disabled} />
        ) : (
            <>
                <ArchiveRowButton rowId={rowData.rowId} archived={archived} disabled={disabled} />
                <EditRowButton rowData={rowData} disabled={disabled} />
            </>
        )}
    </Box>
);
